import { Paragraph } from '@scouts/ui'

import { BankingPromotionLink } from './BankingPromotionLink'

export const BankingPromotionParagraph = () => {
    return (
        <Paragraph>
            ¡En BBVA es posible! <BankingPromotionLink>Abre una Cuenta Negocios Bienvenida</BankingPromotionLink> para
            autónomos y disfruta de todas sus ventajas que harán más fácil tu día a día.
        </Paragraph>
    )
}
